"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeButtonSchemaPropTypes = void 0;

var _reactDesc = require("react-desc");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var makeButtonSchemaPropTypes = function makeButtonSchemaPropTypes(extensions) {
  return _objectSpread({
    text: _reactDesc.PropTypes.string.description("The button's text"),
    disabled: _reactDesc.PropTypes.bool.description('Defines if the button will be disabled').defaultValue('false'),
    size: _reactDesc.PropTypes.oneOf(['small', 'medium', 'large', 'extraLarge']).description('Defines the size of the button').defaultValue('medium'),
    icon: _reactDesc.PropTypes.element.description('Which `iconix` icon to render'),
    iconPosition: _reactDesc.PropTypes.oneOf(['left', 'right']).description('In which side of the text the icon should be rendered').defaultValue('left'),
    intent: _reactDesc.PropTypes.oneOf(['success', 'danger']).description('Applies desired hover state of button'),
    kind: _reactDesc.PropTypes.oneOf(['primary', 'secondary']).description('Applies inverted button styles'),
    loading: _reactDesc.PropTypes.bool.description('Defines if the loading animation within the button should be displayed').defaultValue('false'),
    loadingText: _reactDesc.PropTypes.string.description('Loading animation text'),
    minWidth: _reactDesc.PropTypes.string.description('A pass-through CSS value for the min-width attribute'),
    variant: _reactDesc.PropTypes.oneOf(['normal', 'inverted']).description('Applies secondary button styles')
  }, extensions);
};

exports.makeButtonSchemaPropTypes = makeButtonSchemaPropTypes;
var schema = (0, _reactDesc.describe)({
  displayName: 'Button'
});
schema.propTypes = makeButtonSchemaPropTypes();
var _default = schema;
exports.default = _default;